import * as R from 'ramda';
import * as Yup from 'yup';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
import { MAIL_SENDING_REPLY_TO_OPTIONS } from '../../../helpers/options';
// feature master-invoice
import * as LC from '../constants';
//////////////////////////////////////////////////

export const getValidationSchema = ({ integrationType }) => {
  if (R.equals(integrationType, LC.INTEGRATION_TYPE_RTS_FINANCIAL_MANUAL)) return {};

  return {
    [LC.DOCUMENT_TEMPLATE]: Yup.string()
      .nullable(true)
      .required(G.getWindowLocale('validation:field-required', 'Field is Required')),
  };
};

export const defaultValues = {
  [LC.MERGE_FILES]: true,
  [LC.SEND_EMAILS]: false,
  [LC.DOCUMENT_TYPES]: null,
  [LC.INTEGRATION_TYPE]: null,
  [LC.DOCUMENT_TEMPLATE]: null,
  [LC.VENDOR_DOCUMENT_TYPES]: null,
  [GC.FIELD_MAIL_SENDING_REPLY_TO]: null,
};

export const getFields1 = (mailSendingIntegrationExists) => [
  {
    type: 'toggle',
    shouldCustomChange: true,
    fieldName: LC.MERGE_FILES,
    label: ['titles:merge-files'],
  },
  {
    type: 'toggle',
    shouldCustomChange: true,
    fieldName: LC.SEND_EMAILS,
    label: ['titles:send-emails'],
    inputWrapperStyles: { mt: 10 },
    disabled: G.isNilOrEmpty(mailSendingIntegrationExists),
    title: mailSendingIntegrationExists
      ? G.getWindowLocale(
        'messages:you-do-not-have-mail-sending-integration',
        "You don't have mail sending integration",
      )
      : null,
  },
];

const inputWrapperStyles = {
  mb: 15,
  mr: 25,
  width: 200,
};

export const getFields2 = (
  templateOptions,
  documentTypeOptions,
  sendEmails = false,
  activeFactoringIntegration,
  vendorDocumentTypeOptions,
) => [
  {
    type: 'select',
    inputWrapperStyles,
    options: templateOptions,
    label: ['titles:template'],
    fieldName: LC.DOCUMENT_TEMPLATE,
    isRequired: G.notEquals(activeFactoringIntegration, LC.INTEGRATION_TYPE_RTS_FINANCIAL_MANUAL),
  },
  {
    type: 'select',
    inputWrapperStyles,
    shouldCustomChange: true,
    fieldName: LC.INTEGRATION_TYPE,
    label: ['titles:factoring-name'],
    options: R.compose(
      G.addEmptyOptionToDropDown,
      R.filter(R.propEq(activeFactoringIntegration, GC.FIELD_VALUE)),
    )(LC.INTEGRATION_TYPE_OPTIONS),
  },
  {
    isMulti: true,
    inputWrapperStyles,
    type: 'reactSelect',
    options: documentTypeOptions,
    fieldName: LC.DOCUMENT_TYPES,
    useMultiSelectMaxHeight: true,
    label: ['titles:default-document-types'],
  },
  {
    type: 'select',
    inputWrapperStyles,
    label: ['titles:reply-to'],
    fieldName: GC.FIELD_MAIL_SENDING_REPLY_TO,
    fieldGroupDisplay: G.ifElse(sendEmails, 'flex', 'none'),
    options: G.addEmptyOptionToDropDown(MAIL_SENDING_REPLY_TO_OPTIONS),
  },
  {
    isMulti: true,
    inputWrapperStyles,
    type: 'reactSelect',
    options: vendorDocumentTypeOptions,
    fieldName: LC.VENDOR_DOCUMENT_TYPES,
    label: ['titles:vendor-document-types'],
  },
];
